import * as client_hooks from '../../../src/hooks.client.ts';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39')
];

export const server_loads = [];

export const dictionary = {
		"/": [4],
		"/api/unsubscribe": [5],
		"/app": [6,[2]],
		"/app/bug-report": [7,[2]],
		"/app/chat": [8,[2]],
		"/app/habits": [9,[2]],
		"/app/notes": [10,[2]],
		"/app/partnerships": [13,[2]],
		"/app/partnerships/[id]": [14,[2]],
		"/app/partnerships/[id]/edit": [15,[2]],
		"/app/partnerships/[id]/settings": [16,[2]],
		"/app/partner/connect": [11,[2]],
		"/app/partner/join/[token]": [12,[2]],
		"/app/profile": [17,[2]],
		"/app/profile/change-password": [18,[2]],
		"/app/punishments": [19,[2]],
		"/app/rewards": [20,[2]],
		"/app/settings": [21,[2]],
		"/app/settings/change-password": [22,[2]],
		"/app/solo/setup": [23,[2]],
		"/app/subscription": [24,[2]],
		"/app/themes": [25,[2]],
		"/app/upgrade": [26,[2]],
		"/auth/forgot-password": [27,[3]],
		"/auth/login": [28,[3]],
		"/auth/register": [29,[3]],
		"/auth/reset-password/[token]": [30,[3]],
		"/auth/verify-email": [31,[3]],
		"/classic": [32],
		"/partner/invite/[token]": [33],
		"/partner/qrcode/[token]": [34],
		"/privacy": [35],
		"/pwa-info": [36],
		"/sentry-example-page": [37],
		"/terms": [38],
		"/unsubscribe": [39]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';